import EntitySearchInput from 'components/form/EntitySearch/EntitySearchInput';

import Cliente from 'entity/Cliente';

import { usePerfil } from 'useAuth';

export default function SeletorCliente({
    name = "cliente",
    label = "Cliente",
    fieldFilterAdd,
    autoSelectOne,
    handleChange,
    InputLabelProps,
    sx,
    multiple,
    ...otherProps
}) {
    const perfil = usePerfil();
    let tipoPerfil = 'cliente'
    if (perfil) {
        if (perfil.grupoPermissao) {
            if (perfil.grupoPermissao.uid === "r9jrEQXznNgjrZTGCfch") {
                tipoPerfil = 'admin'
            }
            if (perfil.grupoPermissao.uid === "RECT03jkyTQW9B2OMz47") {
                tipoPerfil = 'tecnico'
            }
            if (perfil.grupoPermissao.uid === "-OXwisN4fkQV3l7Uzeui") {
                tipoPerfil = 'lider'
            }
        }
    }

    const extraQuery = (col) => {
        if (perfil) {
            if (tipoPerfil === "cliente") col = col.where('perfisAutorizado.' + perfil.uid, '==', true);
            if (tipoPerfil === "tecnico") col = col.where('perfisAutorizado.' + perfil.uid, '==', true);
            if (tipoPerfil === "lider") {
                // se mais de 10 clientes, pode ser que precisaremos de uma nova abordagem
                // existe um limitador de 10 no operador 'in'
                if (perfil.clientesPermitidos && Array.isArray(perfil.clientesPermitidos) && perfil.clientesPermitidos.length > 0) {
                    col = col.where('cliente.uid', 'in', perfil.clientesPermitidos.map(cliente => cliente.uid));
                }
            }
        }
        return col;
    }

    return (
        <EntitySearchInput
            name={name}
            label={label}
            EntityClass={Cliente}
            extraQuery={extraQuery}
            fieldFilterAdd={fieldFilterAdd}
            onChange={handleChange}
            autoSelectOne={autoSelectOne}
            loadOnRender
            InputLabelProps={InputLabelProps}
            sx={sx}
            multiple={multiple}
            {...otherProps}
        />
    )
}
